import { render } from "./ProcessManager.vue?vue&type=template&id=4acb9510"
import script from "./ProcessManager.vue?vue&type=script&lang=js"
export * from "./ProcessManager.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__